import { Object } from "core-js";
import constants from "../../common/constants";

import BrandHelper from "../brand/brand-helper";

/* eslint-disable */
const specialCharsOrNumbers = /[\"\!\#\$\%\&\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@\]\[\\\^\_\{\|\}\~\d]/;
const isEmailRegExp = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const isEmail = string => {
  if (!string) {
    return false;
  }
  const result = isEmailRegExp.exec(string);
  return result && result[0].length === string.length;
};

export const validateSsn = values => {
  const errors = {};
  if (!values || !values.ssn) {
    errors.ssn = "ssn_validation.empty-ssn";
    return errors;
  }
  if (values && values.ssn.length < 12)
    errors.ssn = "ssn_validation.ssn-too-short";
  if (values && values.ssn.length > 12)
    errors.ssn = "ssn_validation.ssn-too-long";
  return errors;
};

const shoudValidateClinicCity = () => {
  const brand = BrandHelper.getMyDomainObject();
  return brand.clinicCityEnabled;
};
const shouldValidateEmail = () => {
  const brand = BrandHelper.getMyDomainObject();
  return brand.registrationWithEmailEnabled;
};

const MIN_STR_LENGTH = 2;
const MAX_STR_LENGTH = 255;

export const validateQuestion = values => {
  const errors = {};
  if (!values || !values.answer) {
    errors.answer = "Required";
  }
  return errors;
};
export const validateSexAndAge = values => {
  const errors = {};

  if (values && !values.height) {
    errors.height = "sex_and_age.height_validation";
  }
  if (values && !values.weight) {
    errors.weight = "sex_and_age.weight_validation";
  }
  if (values && !values.birthday) {
    errors.birthday = "sex_and_age.required";
  }
  if (values && !values.sex) {
    errors.sex = "sex_and_age.required";
  }

  if (
    values &&
    values.height &&
    (values.height < constants.heightValidation.min ||
      values.height > constants.heightValidation.max)
  ) {
    errors.height = "sex_and_age.height_validation";
  }
  if (
    values &&
    values.weight &&
    (values.weight < constants.weightValidation.min ||
      values.weight > constants.weightValidation.max)
  ) {
    errors.weight = "sex_and_age.weight_validation";
  }
  return errors;
};

export const validateGeneralInfo = values => {
  const errors = {};
  const medicalPropertiesErrros = {};
  const { medical_properties } = values;

  if (!medical_properties.sex) {
    medicalPropertiesErrros.sex = "general-info-form.error.sex";
  }
  if (!medical_properties.weight || medical_properties.weight < 1) {
    medicalPropertiesErrros.weight = "general-info-form.error.weight";
  }
  if (!medical_properties.height || medical_properties.height < 1) {
    medicalPropertiesErrros.height = "general-info-form.error.height";
  }
  if (!medical_properties.age || medical_properties.age < 1) {
    medicalPropertiesErrros.age = "general-info-form.error.age";
  }
  if (
    !values.first_name ||
    values.first_name.length > MAX_STR_LENGTH ||
    values.first_name.length < MIN_STR_LENGTH
  ) {
    errors.first_name = "general-info-form.error.first_name.length";
  } else if (specialCharsOrNumbers.exec(values.first_name)) {
    errors.first_name = "general-info-form.error.first_name.special-characters";
  }
  if (
    !values.last_name ||
    values.last_name.length > MAX_STR_LENGTH ||
    values.last_name.length < MIN_STR_LENGTH
  ) {
    errors.last_name = "general-info-form.error.last_name.length";
  } else if (specialCharsOrNumbers.exec(values.last_name)) {
    errors.last_name = "general-info-form.error.last_name.special-characters";
  }
  if (Object.keys(medicalPropertiesErrros).length > 0) {
    errors.medical_properties = medicalPropertiesErrros;
  }
  return errors;
};

export const validateSignUp = values => {
  const errors = {};
  if (shouldValidateEmail()) {
    if (!values || !values.email) errors.email = "sign-up.error.email";
    if (values && values.email && !isEmail(values.email)) {
      errors.email = "sign-up.error.email";
    }
  }
  if (shoudValidateClinicCity() && values && !values.clinic_city)
    errors.clinic_city = "sign-up.error.clinic_city";

  return errors;
};

export const validateConfirmEmail = values => {
  const errors = {};
  const validEmailEntered = isEmail(values.email);
  if (!validEmailEntered) {
    errors.email = "sign-up.error.email";
  }
  if (!values.code) {
    errors.code = "sign-up.error.code";
  }
  return errors;
};

export const validateCreatePassword = values => {
  const errors = {};
  if (!values.password1) {
    errors.password1 = "sign-up.error.password.missing";
    return errors;
  }

  if (
    values &&
    values.password1 &&
    (values.password1.length < 6 || values.password1.length > 100)
  ) {
    errors.password1 = "sign-up.error.password.short";
    return errors;
  }

  if (
    values.password1 &&
    values.password2 &&
    values.password1 !== values.password2
  ) {
    errors.password2 = "sign-up.error.password.missmatch";
  }
  return errors;
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/modules/utils/validations.js